import {
  LOGIN_SUCCESS_ACTION,
  LOGIN_FAILURE_ACTION,
  LOGOUT_SUCCESS_ACTION,
  LOGOUT_FAILURE_ACTION,
  SET_EMAIL,
} from "../actions/types";
import moment from "moment";
import { setupAxios } from "../util";
import { toast } from "react-semantic-toasts";

const INIT_STATE = {
  uploadIncomplete: false,
};
export default function (state = INIT_STATE, action) {
  switch (action.type) {
    case LOGIN_SUCCESS_ACTION:
      console.log(action.payload,'payload')
      state = {
        email: action.payload.email,
        loginId: action.payload.userId,
        location: action.payload.location,
        accessToken: action.payload.access_token,
        userName:action.payload.userName,
        role: action.payload.role,
        expiresIn: moment().add(action.payload.expires_in, "seconds").format(),
        loginError: false,
        message: action.payload.message,
      };
      setTimeout(() => {
        toast({
          type: "info",
          title: action.payload.message,
          description: "",
          time: 3000,
        });
      }, 0);
      setupAxios(state.accessToken);
      return state;

    case LOGIN_FAILURE_ACTION:
      console.log("Login Filure - auth_reduce.js")
      state = {
        loginError: true,
      };
      return state;

    case LOGOUT_SUCCESS_ACTION:
      state = {};
      state.logoutError = false;
      return state;

    case LOGOUT_FAILURE_ACTION:
      state.logoutError = true;
      return state;
   
    case SET_EMAIL:
      state.loginId = action.payload;
      return state;
  }

  if (state.accessToken) {
    setupAxios(state.accessToken);
  }

  return state;
}
